import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/**
 * @description: [引入分组路由->常量大写]
 * @author 吴汉良
 * @time [2019.06.19]
 */

//用户认证信息  包含和用户有关的路由 个人信息等
import AUTH from "./modules/Auth";

// 物流公司路由 包含公司列表和公司详情信息
import COMPANY from "./modules/Company";

//消息动态
import DYNAMIC from "./modules/Dynamic";

//入驻路由
import ENTER from "./modules/Enter";

//首页路由
import HOME from "./modules/Home";

//发布路由
import INVITEBUSINESS from "./modules/inviteBusiness/inviteBusiness.js";

const router = new Router({
  routes: [
    ...HOME,
    ...COMPANY,
    ...DYNAMIC,
    ...ENTER,
    ...AUTH,
    ...INVITEBUSINESS
  ]
});

router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem("useCompany") == "hdzxcc") {
    window.document.title = "衡东专线查查";
  }
  if (sessionStorage.getItem("useCompany") == "hyzxcc") {
    window.document.title = "好运专线查查";
  }
  if (sessionStorage.getItem("useCompany") == "byzxcc") {
    window.document.title = "百驿专线查查";
  }
  if (sessionStorage.getItem("useCompany") == "linanzxcc") {
    window.document.title = "林安专线查查";
  }
  if (sessionStorage.getItem("useCompany") == "ywglg") {
    window.document.title = "义乌公路港专线查查";
  }

  wx.miniProgram.postMessage({ data: { shareURL: location.href } });
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (
      !localStorage.getItem("userId") &&
      localStorage.getItem("authorization")
    ) {
      localStorage.setItem(
        "userId",
        "Bearer " + localStorage.getItem("authorization")
      );
    }
    if (localStorage.getItem("userId")) {
      next();
    } else {
      if (Vue.prototype.isWeiXin()) {
        wx.miniProgram.getEnv(function(res) {
          localStorage.setItem("zxRedirction", from.fullPath);
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url:
                "/pages/wxLogin/wxLogin?redirection=" +
                encodeURIComponent(from.fullPath)
            });
          }
        });
        next({
          name: "auth-login",
          query: {
            redirect: to.fullPath,
            goBack: from.fullPath
            //params: from.query
          }
        });
      } else {
        next({
          name: "auth-login",
          query: {
            redirect: to.fullPath,
            goBack: from.fullPath
            //params: from.query
          }
        });
      }
    }
  } else {
    next();
  }
});

//ios 微信分享，从已配置过分享的页面，进入需要再次配置分享的页面；wxready会直接触发，且会被前面的配置影响（具体什么影响不详）
//ios # 后面的全部不识别； ios只能获取进入页链接，安卓能获取当前页链接
router.beforeEach((to, from, next) => {
  if (to.fullPath !== window.location.hash.slice(1) && to.meta.isWXShare) {
    let href = window.location.href;
    href = href.replace(href.hash, "#" + to.fullPath); // hash模式下的页面路径拼接方式
    window.location.hash = to.fullPath;
    window.location.reload();
    next();
  } else {
    next();
  }
});

export default router;
